import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Elements, StripeProvider } from "react-stripe-elements";
import { bindActionCreators } from "redux";
import { getSubscriptionPlan } from "../../../modules/subscription/action";
import UpgradePlanPayment from "./UpgradePlanPayment";
import { config } from "../../../config/appConfig";








const styles = {
  card: {
    minWidth: 275,
    border: "2px solid #005458",
    borderRadius: "0 90px"
  },
  cardContent1: {
    height: 150
  },
  cardContent2: {
    height: "auto"
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  col: {
    backgroundColor: "#00bc84",
    color: "#fff"
  },
  expand: {
    transform: "rotate(0deg)",
    float: "right"
  },
  expandOpen: {
    transform: "rotate(180deg)",
    float: "right"
  }
};

class CounterPartyBilling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      expanded: [false, false, false],
      currentSubscriptionPlan: {},
      newPlan: {},
      openPaymentDialog: true
    };
  }


  handleClose = () => {
    // this.setState({ openPaymentDialog: false });
  };
  handleredirectionClode = () => {
    this.setState({ openPaymentDialog: false });
    window.location.href = "/app";
  };

  render() {
    const { subscriptionList = [], classes } = this.props;
    return (
      <div className="innermainform">
        {/* <div className="textRequired">
            {this.state.fetchingComplete ? Object.keys(subscriptionList).filter((data)=>{
                return subscriptionList[data].id === userDetail().planId
            }).map((data)=>{
                return `Your current plan is ${subscriptionList[data].name} Plan`
            }):null}
        </div> */}
        {this.state.openPaymentDialog && (
          <StripeProvider apiKey={config.paymentkey}>
            <Elements>
              <UpgradePlanPayment
                amount={100}
                currency={"$"}
                newPlanName={"Basic"}
                currentPlanId={1}
                handleClose={this.handleClose}
                isCounterParty={true}
                handleredirectionClode = {this.handleredirectionClode}
              />
            </Elements>
          </StripeProvider>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    subscriptionList: state.subscriptionList.subscriptionListDetails
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getSubscriptionPlan
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CounterPartyBilling));



// WEBPACK FOOTER //
// ./src/components/private/Billing/CounterPartyBilling.js